// extracted by mini-css-extract-plugin
export default {"login":"Login_login__cGt6A","ChatBtn":"Login_ChatBtn__8Ijyw"};